<template>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const MV_URL = process.env.MUSICVERSE_URL;
const BASE_URL = process.env.BASE_URL;
export default {
  name: 'UpdatePaymentPage',
  data: () => ({
    isMobileLogin: false,
    mv_url: MV_URL,
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode', 'getNextPage']),
    ...mapGetters('AuthModule', ['getUser', 'accessToken']),
  },
  async mounted() {
    let token = '';
    if (this.$route.query._t !== undefined) {
      // eslint-disable-next-line no-underscore-dangle
      token = this.$route.query._t;
      this.isMobileLogin = true;
    } else if (this.accessToken !== '') {
      token = this.accessToken;
    }
    if (token !== '') {
      await this.removeAuthentication({ accessToken: this.accessToken });
      const response = await this.requestMobileAuth(token);
      if (response) {
        const session = await this.requestUpdatePayment({
          success_url: `${BASE_URL}/#/update-payment-success`,
          failed_url: `${BASE_URL}/#/update-payment-failed`,
          cancel_url: `${BASE_URL}/#/update-payment-failed`,
        });
        if (session) {
          this.setLoading();
          await this.$stripe.redirectToCheckout({ sessionId: session.id });
          this.unsetLoading();
        } else {
          this.$router.push({ name: 'UpdatePaymentFailedPage' });
        }
      } else {
        this.$router.push({ name: 'UpdatePaymentFailedPage' });
      }
    }
  },
  methods: {
    ...mapActions('AuthModule', ['requestMobileAuth', 'removeAuthentication']),
    ...mapActions('NotificationModule', ['setNextPage', 'setLoading', 'unsetLoading']),
    ...mapActions('PaymentModule', ['requestUpdatePayment']),
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/UpdatePayment.vue